module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-outbound-fill-752ce068.svg";